// extracted by mini-css-extract-plugin
module.exports = {"share_comment":"share_comment-3W3zQMvx clearfix"};